export function parseHeaders(headers?: string) {
  if (!headers) {
    return {}
  }
  try {
    return JSON.parse(headers)
  } catch (e) {
    return {}
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Playground/util/parseHeaders.ts